import { render, staticRenderFns } from "./EntityTextareaField.vue?vue&type=template&id=2b41fbfd&scoped=true&lang=pug&"
import script from "./EntityTextareaField.vue?vue&type=script&lang=js&"
export * from "./EntityTextareaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41fbfd",
  null
  
)

export default component.exports